import { render } from "./BackLink.vue?vue&type=template&id=1c9ccfed&scoped=true&ts=true"
import script from "./BackLink.vue?vue&type=script&lang=ts"
export * from "./BackLink.vue?vue&type=script&lang=ts"

import "./BackLink.vue?vue&type=style&index=0&id=1c9ccfed&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9ccfed"]])

export default __exports__